import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { isNullOrWhiteSpace } from 'owa-string-utils';
import { CreateSharingLinkFromFileProviderResult } from './CreateSharingLinkFromFileProviderResult';
import { createSharingLinkBasedOnItemIdFromOneDriveConsumer } from './createSharingLinkBasedOnItemIdFromOneDriveConsumer';

export async function createSharingLinkFromFileProvider(
    attachmentDataProviderType: AttachmentDataProviderType,
    dataProviderItemId: string,
    location: string
): Promise<CreateSharingLinkFromFileProviderResult> {
    if (attachmentDataProviderType !== AttachmentDataProviderType.OneDriveConsumer) {
        throw new Error('CreateSharingLinkFromFileProvider only supports OneDriveConsumer.');
    }

    if (isNullOrWhiteSpace(location)) {
        throw new Error('CreateSharingLinkFromFileProvider should have valid location.');
    }

    return await createSharingLinkBasedOnItemIdFromOneDriveConsumer(dataProviderItemId, location);
}
